import * as React from 'react'
import { PiggyBank } from '@sales-center/components'
import {
  OPPORTUNITY_STATUSES,
  OppStatus,
} from '../Opportunities/OpportunityCard/typings'

import { LEAD_STATUSES, LeadStatus } from '../Leads/LeadCard/typings'

import Box from '@mui/material/Box'
import NotInterested from '@mui/icons-material/NotInterested'
import Typography from '@mui/material/Typography'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'
import { Theme, useTheme } from '@mui/material/styles'

const getStyles = (theme: Theme) => ({
  icon: {
    marginRight: theme.spacing(1),
    fontSize: '30px',
  },

  title: {
    fontFamily: 'Source Sans Pro Semibold',
  },
})

interface Props {
  className?: string
  status: LeadStatus | OppStatus
  date: Date | null
  reason?: string
}

export const ClosedDecoration: React.FC<Props> = ({
  className,
  date,
  reason,
  status,
}) => {
  const { formatDate } = useLocalizationDateFormat()
  const styles = getStyles(useTheme())
  return status === LEAD_STATUSES.Open ||
    status === OPPORTUNITY_STATUSES.Open ? null : (
    <Box display="flex" alignItems="center" className={className}>
      {status === OPPORTUNITY_STATUSES.Won ? (
        <PiggyBank sx={styles.icon} />
      ) : (
        <NotInterested sx={styles.icon} />
      )}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          columnGap: 2,
          rowGap: 0.25,
        }}
      >
        <Typography>
          {/* opportunity */}
          {(status === OPPORTUNITY_STATUSES.Lost ||
            status === OPPORTUNITY_STATUSES.Won) && (
            <span style={styles.title}>
              Closed {status === OPPORTUNITY_STATUSES.Won ? 'Won' : 'Lost'}
            </span>
          )}
          {/* lead */}
          {status === LEAD_STATUSES.Disqualified && (
            <span style={styles.title}>Disqualified</span>
          )}
          {!!date && <>:&nbsp;{formatDate(date)}</>}
        </Typography>

        {!!reason && (
          <Typography>
            <span style={styles.title}>Reason:</span> {reason}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

ClosedDecoration.displayName = 'ClosedDecoration'
